import { useCakeMakerState, useCakeMakerActions } from '@/store/useCakeMaker'
import { InteractiveLabel } from '../../components/InteractiveLabel'

import { Option } from '../../components/Option'
import { OptionsWrapper } from '../../components/OptionsWrapper'

import {
  TRADITIONAL_PRICE,
  FRUIT_PRICE,
  SPECIAL_PRICE,
  traditionalFillings,
  fruitFillings,
  specialFillings,
} from '../../data/fillings'

import './styles.scss'

export function FillingStep() {
  const { fillings } = useCakeMakerState()
  const { setFilling } = useCakeMakerActions()

  return (
    <div className="filling-step">
      <div className="filling-step__item">
        <InteractiveLabel
          id="traditional-fillings-label"
          priceBy={{ value: TRADITIONAL_PRICE, by: 'kg' }}
        >
          Tradicionais
        </InteractiveLabel>

        <OptionsWrapper aria-labelledby="traditional-fillings-label">
          {traditionalFillings.map((filling) => (
            <Option
              key={filling.id}
              value={filling.name}
              onClick={() => setFilling(filling)}
              selected={fillings.some((f) => f.id === filling.id)}
              description={filling.description}
            />
          ))}
        </OptionsWrapper>
      </div>

      <div className="filling-step__item">
        <InteractiveLabel
          id="fruit-fillings-label"
          priceBy={{ value: FRUIT_PRICE, by: 'kg' }}
        >
          Com frutas frescas
        </InteractiveLabel>

        <OptionsWrapper aria-labelledby="fruit-fillings-label">
          {fruitFillings.map((filling) => (
            <Option
              key={filling.id}
              value={filling.name}
              onClick={() => setFilling(filling)}
              selected={fillings.some((f) => f.id === filling.id)}
              description={filling.description}
            />
          ))}
        </OptionsWrapper>
      </div>

      <div className="filling-step__item">
        <InteractiveLabel
          id="special-fillings-label"
          priceBy={{ value: SPECIAL_PRICE, by: 'kg' }}
        >
          Especiais
        </InteractiveLabel>

        <OptionsWrapper aria-labelledby="special-fillings-label">
          {specialFillings.map((filling) => (
            <Option
              key={filling.id}
              value={filling.name}
              onClick={() => setFilling(filling)}
              selected={fillings.some((f) => f.id === filling.id)}
              description={filling.description}
            />
          ))}
        </OptionsWrapper>
      </div>
    </div>
  )
}
